<template>
  <v-card>
    <div class="d-flex justify-space-between align-center px-4 py-2">
      <h3
        v-text="$t('profile.form.profilePictureUpload')"
        class="primary--text"
      ></h3>
      <v-btn icon @click="$emit('closeEditProfilePicture')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div class="pa-4">
      <!-- UploadButton -->
      <!-- :label="$t('profile.form.profilePictureUpload')" -->
      <v-form v-model="isFormValid" ref="pictureProfileForm" lazy-validation>
        <v-file-input
          v-model="picture"
          outlined
          color="primary"
          accept=".jpeg, .jpg, .png"
          :rules="picture === null || picture === undefined ? [] : pictureRules"
          :prepend-icon="''"
          append-icon="fas fa-image"
          ref="pictureInput"
          :error-messages="errorMessages"
          @focus="errorMessages = ''"
          @input="errorMessages = ''"
        >
        </v-file-input>
      </v-form>

      <v-btn
        @click.stop="uploadFile()"
        color="primary"
        large
        block
        :loading="loading"
        :disabled="!isFormValid"
      >
        {{ $t("profile.form.uploadPicture") }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "AccountEditPictureModal",
  data() {
    return {
      isFormValid: true,
      loading: false,
      picture: null,
      pictureRules: [
        value =>
          value != null || this.$i18n.t("profile.rules.picture.required"),
        value =>
          value.size < 4000000 || this.$i18n.t("share.post.rules.picture.size"),
        value =>
          /image\/png|image\/jpg|image\/jpeg/.test(value.type) ||
          this.$i18n.t("share.post.rules.picture.type")
      ],
      errorMessages: ""
    };
  },

  methods: {
    uploadFile() {
      this.loading = true;
      if (this.$refs.pictureProfileForm.validate()) {
        var picture = new FormData();
        picture.append("profile_picture", this.picture);
        this.$store
          .dispatch("editProfilePicture", picture)
          .then(() => {
            this.$emit("closeEditProfilePicture");
            this.$emit("triggerNewSearch");
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>
